import React from "react"
import { useTranslation } from "react-i18next"
import { useNavigate } from "react-router-dom"

import { PublicLayout } from "layouts/Public"
import { publicRoutes, privateRoutes } from "router/routes"
import { useAuth } from "hooks/useAuth"

import "../features/auth/Auth.scoped.scss"

const NotFound = () => {
    const { t } = useTranslation()
    const { user } = useAuth()
	const navigate = useNavigate()

    const redirect = () => {
        navigate(Boolean(user) ? privateRoutes.home.path : publicRoutes.login.path)
    }

    return (
        <PublicLayout className="px-5 p-12 login-page">
            <div className={"blur"}></div>
            <div className="l-container">
                <div className="text-center text-white">
                    <h1 className="c-h1 mt-12 font-bold text-primary text-center mb-12">{t("notFound.title")}</h1>
                    <button onClick={redirect} className="c-btn c-btn--primary mx-auto px-12">
                        {t("notFound.goback")}
                    </button>
                </div>
            </div>
        </PublicLayout>

    )

}


export default NotFound